var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#2d6e58",
    enableBackground: "new 0 0 20 20",
    height: 512,
    viewBox: "0 0 20 20",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 0c-3.3 0-6 2.7-6 6s6 11 6 11 6-7.7 6-11-2.7-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.3 11.1c-.3.6-.6 1.2-1 1.8 1.7.6 2.7 1.4 2.7 2.1 0 1.2-3.2 3-8 3s-8-1.8-8-3c0-.7 1-1.5 2.7-2.2-.4-.6-.7-1.2-1-1.8-2.3 1-3.7 2.4-3.7 4 0 2.8 4.2 5 9.8 5 5 0 10.2-1.7 10.2-5 0-1.6-1.4-3-3.7-3.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e531fd7542e1ac91374dfb199a06f78a.svg";
export { ForwardRef as ReactComponent };